<template>
  <section class="course__area pt-60 pb-60 grey-bg">
    <div class="container">
      <div class="row align-items-end">
        <div class="col-xxl-5 col-xl-6 col-lg-6">
          <div class="section__title-wrapper mb-60">
            <h2 class="section__title">{{ $t('actions.all1') }} 
              <span class="yellow-bg yellow-bg-big">
                {{ $t('navbar.news') }}<img src="../../assets/img/shape/yellow-bg.png" alt=""></span>
              </h2>
            <p>{{ $t('actions.AllNews') }}</p>
          </div>
        </div>
        <div class="col-xxl-7 col-xl-6 col-lg-6">
          <div class="course__menu d-flex justify-content-lg-end mb-60">
            <div class="masonary-menu filter-button-group">
              <nav>
                <div className="nav nav-tabs justify-content-center" id="portfolio-tab" role="tablist">
                  <button className="nav-link active" id="nav-all-tab" data-bs-toggle="tab" data-bs-target="#nav-all"
                    type="button" role="tab" aria-controls="nav-all" aria-selected="true" @click="categoryChange('')">
                    {{ $t('actions.all1') }}
                    <span class="tag">
                      {{ $t('actions.new') }}
                    </span> </button>
                  <button className="nav-link" data-bs-toggle="tab" type="button" role="tab"
                    @click="sortByCategory('Yangilik')">
                    {{ getName({
                      nameUz: 'Yangiliklar',
                      nameRu: 'Новости',
                      nameEn: 'News',
                    }) }}
                  </button>
                  <button className="nav-link" data-bs-toggle="tab" type="button" role="tab"
                    @click="sortByCategory('Elon')">
                    {{ getName({
                      nameUz: "E'lonlar",
                      nameRu: "Объявления",
                      nameEn: "Announcements",
                    }) }}
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="row grid tab-content">
        <div className="tab-pane fade show active" id="nav-all" role="tabpanel" aria-labelledby="nav-all-tab">
          <div class="container">
            <div class="row">
              <div v-for="(course, index) in sortingNews" :key="index"
                class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 grid-item">
                <div class="course__item white-bg mb-30 fix">
                  <div class="course__thumb w-img p-relative fix">
                    <router-link :to="`/news-details/${course.id}`">
                      <!-- :to="`/news-details/${course.id}`" -->
                      <img height="230" :src="baseUrl + course.image" alt="">
                      <div v-if="!!course.category" class="course__tag">
                        <span class="page__title-pre">
                          {{ course.category == 10 ? 'Yangiliklar' : 'E\'lonlar' }}</span>
                      </div>
                    </router-link>
                  </div>
                  <div class="course__content">
                    <div class="course__meta d-flex align-items-center justify-content-between">
                      <div class="course__lesson">
                        <span><i class="far fa-calendar-check" style="color: #0e1133"></i>{{ course?.created_at?.slice(0, 10) }}</span>
                      </div>
                    </div>
                    <h5 class="course__title" style="height:80px; font-size: 18px; font-weight: 600; margin-bottom: 0;">
                      <router-link :to="`/news-details/${course.id}`">
                       {{ 
                        getName({
                          nameUz: course.title_uz.split(' ').slice(0, 12).join(' '),
                          nameLt: course.title_uz.split(' ').slice(0, 12).join(' '),
                          nameRu: course.title_uz.split(' ').slice(0, 12).join(' '),
                          nameEn: course.title_uz.split(' ').slice(0, 12).join(' '),
                        })
                      }}
                      <span v-if="course.title_uz.split(' ').length > 12">...</span></router-link>
                    </h5>
                  </div>
                  <div class="course__more d-flex justify-content-between align-items-center">
                    <div class="course__btn">
                      <router-link :to="`/news-details/${course.id}`" class="link-btn">
                        <!-- :to="`/news-details/${course.id}`" -->
                        {{ $t('actions.detail') }}
                        <i class="far fa-arrow-right"></i>
                        <i class="far fa-arrow-right"></i>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="float-end">
        <b-pagination v-model="params.data.page" :total-rows="news.total" :per-page="news.itemsPerPage"></b-pagination>
      </div> -->
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '../../mixins/blogMixin';

export default {
  name: 'homeCourse',
  mixins: [BlogMixin],
  data() {
    return {
      params: {
        data: {
          page: 1,
          itemsPerPage: 6,
          sortBy: [],
          sortDesc: [],
          search: '',
        },
        code: ''

      },
      params1: {
        page: 0,
        itemsPerPage: 10,
        sortBy: ["nameUz"],
        sortDesc: [true],
        search: ''
      }
    }
  },
  watch: {
    'params.data.page': {
      handler(vm) {
        this.params.data.page = vm
        this.getNews(this.params)
      }
    }
  },
  created() {
    this.getNews(this.params);
    this.getCategory(this.params1)
  },
  computed: {
    ...mapGetters('news', ['news']),
    ...mapGetters('category', ['category']),
    sortingNews() {
      let filterNews1 = (this.news.results)?.filter((x) => x.status == true)
      return filterNews1?.sort((a, b) => b.id - a.id);
    },
    // context(){
    //   return this.getName({ nameRu: this.rektorat.vazifalari_ru, nameEn: this.rektorat.vazifalari_en, nameUz: this.rektorat.vazifalari_uz })
    // },
  },

  methods: {
    ...mapActions('news', ['getNews', 'getNewsByCategory']),
    ...mapActions('category', ['getCategory']),
    categoryChange(id) {
      this.params.code = id
      this.getNews(this.params)
    },
    sortByCategory(code){
      this.getNewsByCategory(code)
    },
    getCourseTitle(course) {
      const shortName = this.getName({
        nameUz: course.contentUz.split(' ').slice(0, 15).join(' '),
        nameLt: course.contentLt.split(' ').slice(0, 15).join(' '),
        nameRu: course.contentRu.split(' ').slice(0, 15).join(' '),
        nameEn: course.contentEn.split(' ').slice(0, 15).join(' '),
      });
      return `<p style="font-family: sans-serif">${shortName}</p>`;
    },
  }
};
</script>
